export interface CorporateActionsCapsuleConfigState {
    symbol?: string;
    excludeHistorical?: boolean;
    excludeUpcoming?: boolean;
    excludeToday?: boolean;
}

export const initialCorporateActionsCapsuleConfigState: CorporateActionsCapsuleConfigState =
    { excludeHistorical: true };
